import _QRCode from './QRCode';

import './style/index.js';

export * from './type';

export type { QrCodeProps } from './QRCode';

export const QRCode = _QRCode;
export default QRCode;
